import { FormShell, FormGrid, FormField, FormFooter } from '../../../../../../generic/ui/FormLayout'
import { AccentButton } from '../../../../../../generic/ui/Button'
import ClientSelector, { ClientItem } from '../../../../../../generic/ui/ClientSelector/ClientSelector'
import { IClientsItem } from '../../../../../../modules/API/Defaults/models/customers'
import { IPalletListWithDetails } from '../../../../../../modules/API/Pallets/models/palletList'
import PalletActionLayout from '../../shared/components/PalletActionLayout'
import PalletLookupField from '../../shared/components/PalletLookupField'
import FoundPalletCard from '../../shared/components/FoundPalletCard'

type Props = {
  palletNumber: string
  setPalletNumber: (value: string) => void
  isExternal: boolean
  setIsExternal: (value: boolean) => void
  palletFound: IPalletListWithDetails | null
  findPallet: (value?: string) => void
  customerList: IClientsItem[]
  selectedCustomer: IClientsItem | null
  setSelectedCustomer: (customer: IClientsItem | null) => void
  submit: () => void
  canSubmit: boolean
}

const EditCustomerView = ({
  palletNumber,
  setPalletNumber,
  isExternal,
  setIsExternal,
  palletFound,
  findPallet,
  customerList,
  selectedCustomer,
  setSelectedCustomer,
  submit,
  canSubmit,
}: Props) => (
  <PalletActionLayout title='עדכון יעד למשטח'>
    <FormShell>
      <FormGrid>
        <FormField label='מספר משטח' fullWidth>
          <PalletLookupField
            palletNumber={palletNumber}
            onPalletNumberChange={setPalletNumber}
            onScan={(value) => {
              setPalletNumber(value)
              findPallet(value)
            }}
            isExternal={isExternal}
            onToggle={setIsExternal}
          />
        </FormField>

        {palletFound && (
          <FormField fullWidth>
            <FoundPalletCard pallet={palletFound} />
          </FormField>
        )}

        {palletFound && (
          <FormField label='לקוח' fullWidth>
            <ClientSelector
              clients={customerList as unknown as ClientItem[]}
              value={selectedCustomer as unknown as ClientItem | null}
              onSelect={(customer) => setSelectedCustomer(customer as unknown as IClientsItem)}
            />
          </FormField>
        )}
      </FormGrid>

      {canSubmit && (
        <FormFooter>
          <AccentButton type='button' onClick={submit} fullWidth={false}>
            עדכן
          </AccentButton>
        </FormFooter>
      )}
    </FormShell>
  </PalletActionLayout>
)

export default EditCustomerView
